import { SIZE } from '@/pages/Meeting/component/BarragePanel/components/FontSlider';
import { Lang } from '@/types/lang';
import { observable, action, makeObservable } from 'mobx';

class Barrage {
  constructor() {
    makeObservable(this);
  }

  @observable barrageVisible = false;

  @observable fontSize = SIZE[1];
  // 字幕识别源语言
  @observable originLang = Lang.zh;

  //字幕目标语言
  @observable targetLang = Lang.auto;

  @observable translate = false;
  // 设置字幕识别源语言

  @observable mvHeight = 0;
  @observable minHeight = 160;

  @action setMvHeight = (height: number) => {
    this.mvHeight = height;
  };

  @action
  setOriginLang(value: Lang, translate: boolean) {
    this.originLang = value;
    this.translate = translate;
  }
  // 设置字幕目标语言
  @action
  setTargetLang(value: Lang, translate: boolean) {
    this.targetLang = value;
    this.translate = translate;
  }

  @action
  setBarrageFontSize(value: number) {
    this.fontSize = value;
  }
  @action
  setBarrageVisible(visible: boolean) {
    this.barrageVisible = visible;
    if (!visible) {
      this.mvHeight = 0;
    }
  }
}

export default Barrage;
